import api, { adminApiPrefix } from './Api';
import {
  N11OrderFilter,
  n11OrderFilterToQueryParams,
} from '../interfaces/N11/N11OrderFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { N11Order, n11OrderFromResponse } from '../interfaces/N11/N11Order';

const n11AdminApiPrefix = `${adminApiPrefix}/n11`;

export const getN11Orders = async (
  filter: N11OrderFilter,
): Promise<PaginatedResponse<N11Order>> => {
  const response = await api.get(`${n11AdminApiPrefix}/orders`, {
    params: n11OrderFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map(n11OrderFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const checkN11Status = async (): Promise<void> =>
  api.get(`${n11AdminApiPrefix}/status`);
